<template>
  <div class="table_box">
    <el-table :data="displayData">
      <el-table-column prop="date" :label="$t('promotion.redepositBonus.date')">
        <template slot-scope="scope">{{ scope.row.date | dateYearLast }}</template>
      </el-table-column>
      <el-table-column :label="$t('common.depositMethod')">
        <template slot-scope="scope">{{ scope.row.channel.replaceAll('_', ' ').toLowerCase() }}</template>
      </el-table-column>
      <el-table-column :label="$t('promotion.redepositBonus.amount')">
        <template slot-scope="scope"
          >{{ scope.row.currency | currencyToSymbol }}{{ scope.row.depositAmount | formatNumber(2) }}</template
        >
      </el-table-column>
      <el-table-column prop="date" :label="$t('common.feedbackCredit')">
        <template slot-scope="scope">
          <span
            :class="{
              blue: scope.row.creditAmount > 0,
              red: scope.row.creditAmount < 0
            }"
            >{{ formatAmt(scope.row.creditAmount, scope.row.currency) }}</span
          >
        </template>
      </el-table-column>
      <div slot="empty" class="empty">
        <img class="noData_icon" src="@/assets/images/no_data.png" alt />
        <div>{{ $t('loyalty.noData') }}</div>
      </div>
    </el-table>
    <div class="page_box">
      <el-pagination
        :background="true"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="total"
        :current-page="currentPage"
        :page-sizes="[10, 25, 50, 100]"
        @current-change="handleCurrentChange"
        data-testid="pagination"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TradeInfoTable',
  props: { tableData: Array, participantId: String },
  data() {
    return { pageSize: 5, currentPage: 1, displayData: [], total: 0 };
  },
  watch: {
    tableData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.updateData();
        this.total = Array.isArray(val) ? val.length : 0;
      }
    },
    participantId: {
      deep: true,
      immediate: true,
      handler(val) {
        this.resetPage();
      }
    }
  },
  methods: {
    formatAmt(val, currency) {
      let currencySymbol = this.$options.filters.currencyToSymbol(currency);
      let newVal = this.$options.filters.formatNumber(Math.abs(val), 2);
      return `${val < 0 ? '-' : ''}${currencySymbol}${newVal}`;
    },
    handleCurrentChange(pageNumber) {
      this.currentPage = pageNumber;
      this.updateData();
    },
    updateData() {
      this.displayData = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
      this.$emit('update:display-data', this.displayData);
    },
    resetPage() {
      this.currentPage = 1;
      this.updateData();
    }
  }
};
</script>

<style lang="scss" scoped>
.table_box {
  & thead {
    font-family: PingFangSC-Light;
    font-size: 16px;
    text-align: center;
  }
}

/deep/.el-table__body {
  font-family: Oblivian-Bold;
  font-size: 14px;
  line-height: 130%;
  font-weight: normal;
  color: $broker-black;
  text-transform: capitalize;
}

/deep/.cell {
  text-align: center;
  // font-size: 18px;
}

/deep/ td {
  font-family: Oblivian-Bold;
  font-size: 18px;
}

/deep/.el-table th .cell {
  padding: 10px 20px;
}

.blue {
  color: $primary-blue !important;
}
</style>
